module.exports = __webpack_public_path__ + "img/RobotNameGenerator.a1768972.gif";